import * as THREE from "three";
import Experience from "../Experience.js";

export default class EasthWall {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;

    this.setGeometry();
    this.setMaterial();
    this.setMesh();
  }

  setGeometry() {
    this.geometry = new THREE.PlaneGeometry(6, 2.6);
  }

  setMaterial() {
    this.material = new THREE.MeshStandardMaterial({ color: "white" });
  }

  setMesh() {
    this.mesh = new THREE.Mesh(this.geometry, this.material);
    this.mesh.position.set(2.75, 0, 2);
    this.mesh.rotation.set(0, -Math.PI * 0.5, 0);
    this.mesh.receiveShadow = true;
    this.mesh.name = "wall";
    this.scene.add(this.mesh);
  }
}
